
if (window.platform == undefined) {
  var http = "http://103.239.204.52:16000"
} else {
  var http = `http://${window.platform.ip}:${window.platform.port}/`
}
import getAxios from '../js/http.js';

//类型列表
export const getCategoryList = () => {
  return getAxios("get", http + `/zk/category/list`)
};

//热词查询
export const getHotList = () => {
  return getAxios("get", http + `/zk/flag/hotList`)
};

//标签查询
export const getFlagList = (data) => {
  return getAxios("post", http + `/zk/flag/flagList`,data)
};

//搜索
export const searchAll = (data) => {
  return getAxios("post", http + `/zk/goods/search`,data)
};


//收藏
export const collection = (id) => {
  return getAxios("get", http + `/zk/goods/collection/${id}`)
};

//下載
export const download = (id) => {
  return getAxios("get", http + `/zk/goods/download/${id}`)
};

//查看
export const look = (id) => {
  return getAxios("get", http + `/zk/goods/download/${id}`)
};

//喜欢列表
export const getLoveList = (data) => {
  return getAxios("post", http + `/zk/goods/loveList`,data)
};

//获取登录人信息
export const loginUser = () => {
  return getAxios("get", http + `/cas/loginUser`)
};

//跳转登录页
export const logout = () => {
  return getAxios("get", http + `/cas/logout`)
};

//购买记录列表
export const getTradeList = (data) => {
  return getAxios("post", http + `/zk/goods/tradeList`,data)
};

//收藏列表
export const getCollectionList = (data) => {
  return getAxios("post", http + `/zk/goods/collectionList`,data)
};


//收藏删除
export const collectDelete = (id) => {
  return getAxios("get", http + `/zk/goods/collection/delete/${id}`)
};


//浏览
export const previewAdd = (id) => {
  return getAxios("get", http + `/zk/goods/previewAdd/${id}`)
};


//获取详情
export const getInfo = (id) => {
  return getAxios("get", http + `/zk/goods/info/${id}`)
};


